import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_input = _resolveComponent("the-input")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: "Смена номера накладной",
    loading: _ctx.loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.emitSubmit
  }, {
    default: _withCtx(() => [
      _createVNode(_component_the_input, {
        disabled: _ctx.loading,
        placeholder: "Номер накладной",
        value: _ctx.state.invoiceNumber,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.invoiceNumber) = $event)),
        "is-invalid": _ctx.state_form$.invoiceNumber.$error,
        "validation-errors": _ctx.state_form$.invoiceNumber.$errors
      }, null, 8, ["disabled", "value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["loading", "onCancel", "onConfirm"]))
}